import React from 'react';

function ErrorScreen({
    type = 'session_expired',
    title = 'Session Expired',
    message = 'Your session has expired, please reload the experience to be able to use the earned wage access service.',
    onRetry,
}) {
    const handleReload = () => {
        if (onRetry) {
            onRetry();
        } else {
            window.location.reload();
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                backgroundColor: '#f8fafc',
                padding: '20px',
                fontFamily: 'Inter, sans-serif',
            }}>
            <div
                style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    padding: '48px 32px',
                    maxWidth: '480px',
                    width: '100%',
                    textAlign: 'center',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                    border: '1px solid #e2e8f0',
                }}>
                {/* Error Icon */}
                <div
                    style={{
                        width: '64px',
                        height: '64px',
                        backgroundColor: '#fef2f2',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 24px auto',
                    }}>
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="8" x2="12" y2="12" />
                        <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                </div>

                {/* Title */}
                <h1
                    style={{
                        fontSize: '24px',
                        fontWeight: '600',
                        color: '#1f2937',
                        margin: '0 0 16px 0',
                        lineHeight: '1.25',
                    }}>
                    {title}
                </h1>

                {/* Message */}
                <p
                    style={{
                        fontSize: '16px',
                        color: '#6b7280',
                        margin: '0 0 32px 0',
                        lineHeight: '1.5',
                    }}>
                    {message}
                </p>

                {/* Reload Button */}
                <button
                    onClick={handleReload}
                    style={{
                        backgroundColor: '#09768c',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '12px 24px',
                        fontSize: '16px',
                        fontWeight: '500',
                        cursor: 'pointer',
                        transition: 'background-color 0.2s',
                        fontFamily: 'Inter, sans-serif',
                        minWidth: '120px',
                    }}
                    onMouseOver={(e) => {
                        e.target.style.backgroundColor = '#0891b2';
                    }}
                    onMouseOut={(e) => {
                        e.target.style.backgroundColor = '#09768c';
                    }}>
                    Reload Experience
                </button>

                {/* TVFCU Branding */}
                <div
                    style={{
                        marginTop: '32px',
                        paddingTop: '24px',
                        borderTop: '1px solid #e5e7eb',
                    }}>
                    <p
                        style={{
                            fontSize: '14px',
                            color: '#9ca3af',
                            margin: '0',
                            fontWeight: '500',
                        }}>
                        TVFCU Early Pay
                    </p>
                </div>
            </div>
        </div>
    );
}

export default ErrorScreen;
